import { Component, computed, effect, inject, input } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-targeted-frequency-met-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: TargetedFrequencyMetTabComponent },
  ],
  templateUrl: './targeted-frequency-met-tab.component.html',
  styleUrl: './targeted-frequency-met-tab.component.scss',
})
export class TargetedFrequencyMetTabComponent extends TabComponent {
  userId = input.required<string>();
  tabNameKey = input<string>();

  constructor() {
    super();
    effect(() => {
      const key = this.tabNameKey() || 'TargetedFrequencyMet';
      this.name = this.dictionaryService.get(key);
    });
  }

  endpoint = computed(() => `/visits/tables/target-met/${this.userId()}`);

  public async main(): Promise<void> {}
}
